import { render, staticRenderFns } from "./IncidentReport-barcode.vue?vue&type=template&id=e8ed626e&"
import script from "./IncidentReport-barcode.vue?vue&type=script&lang=js&"
export * from "./IncidentReport-barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports